import React from 'react';
import { motion } from 'framer-motion';
import { Zap, BarChart3, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom'; // <--- 1. IMPORT LINK

// We don't need 'onNavigate' anymore, so I removed it from the props
const LandingPage = () => {
    const featureVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    return (
        <div className="min-h-screen bg-darkBg text-white flex flex-col items-center justify-center p-6 text-center overflow-hidden">
            <motion.header
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="relative z-10"
            >
                <div className="flex items-center justify-center gap-4 mb-4">
                    <Zap className="text-neonPink" size={60} />
                    <h1 className="text-7xl font-extrabold custom-glow-text">
                        PiWatch
                    </h1>
                </div>
                <p className="text-2xl text-gray-300 max-w-2xl mx-auto">
                    Monitor, Analyze, and Control your IoT devices in real-time with a futuristic, powerful dashboard.
                </p>
            </motion.header>

            <motion.div
                variants={featureVariants}
                initial="hidden"
                animate="visible"
                className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-8 my-16 max-w-5xl w-full"
            >
                {/* Feature Cards */}
                <motion.div variants={featureVariants} className="glass-card glow-border p-8">
                    <BarChart3 className="text-neonBlue mx-auto mb-4" size={48} />
                    <h3 className="text-2xl font-bold mb-2">Live Analytics</h3>
                    <p className="text-gray-400">Visualize real-time sensor data with dynamic charts and responsive tables.</p>
                </motion.div>
                <motion.div variants={featureVariants} className="glass-card glow-border p-8">
                    <Zap className="text-neonPink mx-auto mb-4" size={48} />
                    <h3 className="text-2xl font-bold mb-2">Device Management</h3>
                    <p className="text-gray-400">Easily add, configure, and monitor the status of all your connected devices.</p>
                </motion.div>
                <motion.div variants={featureVariants} className="glass-card glow-border p-8">
                    <ShieldCheck className="text-green-400 mx-auto mb-4" size={48} />
                    <h3 className="text-2xl font-bold mb-2">Secure & Scalable</h3>
                    <p className="text-gray-400">Built for reliability, ready to scale from a single Pi to an entire network.</p>
                </motion.div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className="relative z-10"
            >
                {/* 2. REPLACED BUTTON WITH LINK TO /auth */}
                <Link to="/auth">
                    <button
                        className="bg-neonBlue text-black px-12 py-4 rounded-lg font-bold text-xl hover:bg-neonPink hover:scale-110 transition-all duration-300 shadow-[0_0_20px_#00ffff]"
                    >
                        Get Started
                    </button>
                </Link>
            </motion.div>

            {/* Background Glow Effect */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-neonPink/20 rounded-full blur-3xl animate-pulse"></div>
        </div>
    );
};

export default LandingPage;